var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.11612 3.11612C3.60427 2.62796 4.39573 2.62796 4.88388 3.11612L20.8821 19.1143L20.8829 19.1151L20.8838 19.116C20.8838 19.1161 20.8839 19.1161 20 20C19.1161 20.8839 19.1161 20.8838 19.116 20.8838L19.1151 20.8829L19.1143 20.8821L3.11612 4.88388C2.62796 4.39573 2.62796 3.60427 3.11612 3.11612ZM20.8839 20.8839C20.3957 21.372 19.6042 21.3719 19.116 20.8838L20 20L20.8838 19.116C21.3719 19.6042 21.372 20.3957 20.8839 20.8839Z",
    fill: "#1F2021"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8839 3.11612C21.372 3.60427 21.372 4.39573 20.8839 4.88388L4.88566 20.8821L4.88488 20.8829L4.88399 20.8838C4.88392 20.8838 4.88388 20.8839 4 20C3.11611 19.1161 3.11615 19.1161 3.11623 19.116L3.11712 19.1151L3.11789 19.1143L19.1161 3.11612C19.6043 2.62796 20.3957 2.62796 20.8839 3.11612ZM3.11611 20.8839C2.62796 20.3957 2.62807 19.6042 3.11623 19.116L4 20L4.88399 20.8838C4.39584 21.3719 3.60427 21.372 3.11611 20.8839Z",
    fill: "#1F2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d0b444da1b7f18bbbf09e49215e36eb5.svg";
export { ForwardRef as ReactComponent };